export const DEFAULT_INPUT_TYPE_AUTOCOMPLETE = 'autocomplete';
export const DEFAULT_INPUT_TYPE_COMMON_INPUT = 'common-input';
export const DEFAULT_INPUT_TYPE_DATE_PICKER = 'date-picker';
export const DEFAULT_INPUT_TYPE_DATE_RANGE = 'date-range';
export const DEFAULT_INPUT_TYPE_CALCULATION_NUMBER_INPUT = 'calculation-number-input';
export const DEFAULT_INPUT_TYPE_CHECKBOX_WITH_LABEL = 'checkbox-with-label';
export const DEFAULT_INPUT_TYPE_DROPZONE = 'input-dropzone';
